import { render, staticRenderFns } from "./WhyGRS.vue?vue&type=template&id=50778250&scoped=true"
import script from "./WhyGRS.vue?vue&type=script&lang=js"
export * from "./WhyGRS.vue?vue&type=script&lang=js"
import style0 from "./WhyGRS.vue?vue&type=style&index=0&id=50778250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50778250",
  null
  
)

export default component.exports